export default __webpack_public_path__ + "static/media/image 9.cf641522.png";